import { render } from "./WeddingInvitationPage.vue?vue&type=template&id=3f28510a"
import script from "./WeddingInvitationPage.vue?vue&type=script&lang=js"
export * from "./WeddingInvitationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__